"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _useRedirect = _interopRequireDefault(require("@sprinx/react-routes/useRedirect"));

var _CompareIcon = _interopRequireDefault(require("@sprinx/react-com/CompareIcon"));

var _Badge = _interopRequireDefault(require("@material-ui/core/Badge"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _useProductComparisonContext = _interopRequireDefault(require("../../products/useProductComparisonContext"));

var _useShoppingRegion = _interopRequireDefault(require("../../shop/useShoppingRegion"));

var _AppBarActionRegion = _interopRequireDefault(require("./AppBarActionRegion"));

var _useCountriesFlag = _interopRequireDefault(require("./useCountriesFlag"));

var _AppBarActionUser = _interopRequireDefault(require("./AppBarActionUser"));

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    about: {
      color: theme.palette.common.black,
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2)
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      minHeight: theme.spacing(6)
    },
    icon: {
      fill: theme.palette.common.black,
      width: 24,
      height: 24
    },
    iconContainer: {
      '& svg': {
        width: 24,
        height: 24
      }
    }
  };
}, {
  name: 'AppBarActions'
});

var AppBarActions = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      onClose = _ref.onClose,
      variant = _ref.variant;
  var classes = useStyles({
    classes: pClasses,
    className: className
  });

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      chooseLang = _React$useState2[0],
      setChooseLang = _React$useState2[1];

  var _useProductComparison = (0, _useProductComparisonContext.default)(),
      comparedProducts = _useProductComparison.comparedProducts;

  var setRedirect = (0, _useRedirect.default)();
  var region = (0, _useShoppingRegion.default)();
  var countriesFlag = (0, _useCountriesFlag.default)();
  var currentRegion = countriesFlag.find(function (i) {
    return i.region === region;
  });

  var handleClick = _react.default.useCallback(function (path) {
    return function () {
      onClose();
      setRedirect(path);
    };
  }, [onClose, setRedirect]);

  return !chooseLang ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container,
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: handleClick('/compare')
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Compare"
  }, /*#__PURE__*/_react.default.createElement(_Badge.default, {
    badgeContent: comparedProducts.length,
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_CompareIcon.default, {
    className: classes.icon
  })))), /*#__PURE__*/_react.default.createElement(_AppBarActionUser.default, {
    variant: variant,
    path: "/profile"
  }), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: classes.iconContainer,
    onClick: function onClick() {
      return setChooseLang(true);
    }
  }, currentRegion.icon)) : /*#__PURE__*/_react.default.createElement(_AppBarActionRegion.default, {
    onChange: setChooseLang
  });
});

AppBarActions.displayName = 'AppBarActions';
process.env.NODE_ENV !== "production" ? AppBarActions.propTypes = {
  classes: _propTypes.default.shape({
    about: _propTypes.default.string,
    container: _propTypes.default.string,
    icon: _propTypes.default.string,
    iconContainer: _propTypes.default.string,
    language: _propTypes.default.string,
    languageIcon: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  onClose: _propTypes.default.func,
  variant: _propTypes.default.oneOf(['none', 'menuItem', 'standalone'])
} : void 0;
AppBarActions.defaultProps = {
  classes: undefined,
  className: undefined,
  onClose: undefined,
  variant: 'standalone'
};
var _default = AppBarActions;
exports.default = _default;